import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Portfolio from './pages/Portfolio';
import HireMe from './pages/HireMe';
import HebrewCV from './pages/HebrewCV';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="/hire-me" element={<HireMe />} />
        <Route path="/cv" element={<HebrewCV />} />
      </Routes>
    </BrowserRouter>
  );
}
